<template>
	<Row class="page-container-row">
		<Col
			class="width-limit-page-col"
			:span="24"
			:offset="0"
			:lg="{ span: 18, offset: 3 }"
			:xl="{ span: 12, offset: 6 }"
		>
			<PageContainer :withCloseButton="true">
				<Card :title="$t('tempPasswordChangePage.title')">
					<p>{{ $t('tempPasswordChangePage.description') }}</p>
					<Form
						:model="formState"
						:label-col="{ span: 12 }"
						:wrapper-col="{ span: 12 }"
						:colon="false"
						autocomplete="off"
					>
						<FormItem
							:label="$t('account.password1')"
							v-bind="validateInfos.password1"
						>
							<InputPassword
								ref="passwordField"
								v-model:value="formState.password1"
								@keyup.enter="onSubmit"
							/>
						</FormItem>

						<FormItem
							:label="$t('account.password2')"
							v-bind="validateInfos.password2"
						>
							<InputPassword v-model:value="formState.password2" @keyup.enter="onSubmit"/>
						</FormItem>
					</Form>
					<template #actions>
						<Button type="primary" @click.prevent="onSubmit" :loading="isLoading">{{ $t('account.passwordButtonLabel') }}</Button>
					</template>
				</Card>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { reactive, ref, nextTick, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Row, Col, Card, Button, Form, FormItem, InputPassword, message } from 'ant-design-vue';

import Api from '@/api/Api';
import { showErrorMessage } from '@/components/common/errorMessage';
import PageContainer from '@/components/common/PageContainer';

const useForm = Form.useForm;

export default {
	components: {
		Row, Col, Card, Button, Form, FormItem,
		InputPassword, PageContainer,
	},
	setup() {
		const router = useRouter();
		const { t } = useI18n();

		const formState = reactive({
			password1: '',
			password2: '',
		});
		const passwordField = ref(null);
		const validatePass = async (_rule, value) => {
			if (value === '') {
				return Promise.reject(t('account.messages.repeatPassword'));
			}
			if (value !== formState.password1) {
				return Promise.reject(t('account.messages.checkPassword'));
			}
			return Promise.resolve();
		};

		const rulesRef = reactive({
			password1: [{
				required: true,
				message: t('account.messages.enterNewPassword'),
			}],
			password2: [{ validator: validatePass }],
		});
		const { validate, validateInfos } = useForm(formState, rulesRef);
		const isLoading = ref(false);
		const onSubmit = () => {
			validate().then(() => {
				isLoading.value = true;
				Api.changeTempPassword(
					formState.password1,
					response => {
						isLoading.value = false;
						if (response.status === 'ok') {
							message.success(t('account.messages.passwordSuccess'));
							router.push({
								name: 'home-map',
							});
						} else {
							showErrorMessage(response.errors);
						}
					},
					error => {
						isLoading.value = false;
						let errors = error.response.data;
						showErrorMessage(errors);
					},
				);
			}).catch(() => {
				isLoading.value = false;
			});
		};

		onMounted(() => {
			nextTick(() => {
				if (passwordField.value?.focus) {
					passwordField.value.focus();
				}
			});
		});

		return {
			formState,
			validateInfos,
			isLoading,
			onSubmit,
			passwordField,
		};
	},
};
</script>
